import React from "react";
interface CameraProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: string;
}

const IconCamera2: React.FC<CameraProps> = ({ className, width, height, fill }) => (
  <svg width="25" height="22.222" viewBox="0 0 25 22.222" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 17.844q2.171 0 3.689-1.519 1.521-1.521 1.519-3.689t-1.519-3.692Q14.671 7.428 12.5 7.428T8.811 8.944t-1.519 3.692 1.519 3.689q1.518 1.521 3.689 1.519m0-2.315a2.8 2.8 0 0 1-2.056-.839 2.8 2.8 0 0 1-.837-2.056q0-1.215.839-2.053a2.8 2.8 0 0 1 2.054-.839q1.214 0 2.053.84.839.837.839 2.054 0 1.214-.839 2.054a2.78 2.78 0 0 1-2.053.838m-9.26 6.365q-.954 0-1.635-.681a2.22 2.22 0 0 1-.681-1.633V5.69q0-.956.681-1.635.682-.681 1.635-.681h3.646l1.447-1.56a2.32 2.32 0 0 1 1.709-.753h4.917q.493 0 .942.203t.767.55l1.447 1.563h3.646q.954 0 1.635.681.681.679.681 1.635v13.889q0 .954-.681 1.635t-1.635.681zm0-2.314h18.519V5.69h-4.688l-2.113-2.315H10.04L7.931 5.692H3.239z"
      fill="#1C1B1F"
    />
  </svg>
);
export default IconCamera2;
